export const MuiIconButtonNode = {
  styleOverrides: {
    root: {
      "&.Mui-disabled": {
        cursor: "default",
      },
    },
  },
};
